import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", {
    "aria-label": "typing indicator",
    class: _normalizeClass({
    [_ctx.getClass('bot')]:_ctx.typingType==0 || _ctx.typingType==3,
    [_ctx.getClass('user')]:_ctx.typingType==1
})
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('bubble'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.getClass('typing'))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.getClass('blink1'))
        }, null, 2 /* CLASS */),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.getClass('blink2'))
        }, null, 2 /* CLASS */),
        _createElementVNode("span", {
          class: _normalizeClass(_ctx.getClass('blink3'))
        }, null, 2 /* CLASS */)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}